import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { getVacations } from "../Services/vacationsService";
import ListVacation from "./ListVacation";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SliderCards() {
  const [vacations, setVacations] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  useEffect(() => {
    let active = true;
    getVacations(0, {}).then(data => { if (active) setVacations(data || []); })
      .catch(() => { if (active) setVacations([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  if (loading) return <p role="status" className="p-6 text-slate-600">{t("loading", "Chargement…")}</p>;
  if (!vacations.length) return <p className="rounded-2xl border border-slate-200 bg-slate-50 p-8 text-center text-slate-600">{t("vacation.no_listings", "Aucune location de vacances disponible pour le moment.")}</p>;
  const count = vacations.length;
  const settings = {
    dots: false, infinite: false, autoplay: false, speed: 350,
    slidesToShow: Math.min(count, 4), slidesToScroll: 1, arrows: true,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: Math.min(count, 3) } },
      { breakpoint: 900, settings: { slidesToShow: Math.min(count, 2) } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };
  return <div className="lina-slider"><Slider {...settings}>
    {vacations.map(item => <ul key={item.id || item.ID} className="h-full"><ListVacation listing={item} isHome /></ul>)}
  </Slider></div>;
}
